import React from "react";
import { Tag, Space, Button, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

const getRoleDisplay = (role) => {
  if (role === "ADMIN") return { label: "Admin", color: "#e29b45" };
  if (role === "ANALYST") return { label: "Analyst", color: "#2ecc71" };
  if (role === "VIEWER") return { label: "Viewer", color: "#0d2e4d" };
  return { label: role || "N/A", color: "#6c757d" };
};

export default function JeyedaUsersTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  onEditRole,
  onDeleteUser,
  isRoleUser,
}) {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "10%",
      sorter: (a, b) =>
        (a.id || "").toString().localeCompare((b.id || "").toString()),
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      width: "25%",
      sorter: (a, b) => (a.username || "").localeCompare(b.username || ""),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "30%",
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      width: "20%",
      render: (role) => {
        const { label, color } = getRoleDisplay(role);
        return <Tag color={color}>{label}</Tag>;
      },
      sorter: (a, b) => (a.role || "").localeCompare(b.role || ""),
    },
  ];

  if (!isRoleUser) {
    columns.push({
      title: "Actions",
      key: "actions",
      width: "15%",
      render: (_, record) => (
        <Space size="small">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEditRole(record)}
            style={{ color: "#e29b45" }}
            title="Edit Role"
          />
          <Popconfirm
            title="Delete User"
            description={`Are you sure you want to delete user ${record.username}?`}
            onConfirm={() => onDeleteUser(record.id)}
            okText="Delete"
            cancelText="Cancel"
            okButtonProps={{ danger: true }}
          >
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              title="Delete User"
            />
          </Popconfirm>
        </Space>
      ),
    });
  }

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
